// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".error-box-count[data-v-eef20708]{color:rgba(55,59,60,.7)}", "",{"version":3,"sources":["webpack://./resources/client/modules/settings/components/ImportValidationModal.vue"],"names":[],"mappings":"AAGA,kCAAmB,uBADnB","sourcesContent":["\n@import \"../../../styles/variables/variables\";\n\n.error-box-count { color: $text-muted; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
